import type { FaireProductEntity } from "../../entity_types/product";

export const p_7dtjurg7gs: FaireProductEntity = {
  token: "p_7dtjurg7gs",
  type: "product",
  name: "Soul Eater, Vol. 3",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/1e0643efcbe4a8aae82fc7a0586b15a45e5932ca806c6b7412d985af5e45325e.webp",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Tsubaki and Black*Star set off on their most difficult mission yet: a battle with the Uncanny Sword Masamune, a soul on the brink of becoming a Kishin. But this fight holds personal significance for Tsubaki - their target is her older brother. Jealous of her inherited talents, Masamune is holding nothing back. Usually docile and complacent, Tsubaki must find the strength to overtake the Uncanny Sword before she too is sucked into the darkness.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:37.151Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
